var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: _vm.color,
        "stroke-width": "3px",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
      },
    },
    [
      _c("circle", { attrs: { cx: "10.5", cy: "10.5", r: "7.5" } }),
      _vm._v(" "),
      _c("line", { attrs: { x1: "21", y1: "21", x2: "15.8", y2: "15.8" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }